<div class="modal-wrapper" [class.has-pdf-preview]="previewUrl">
    <button class="material-icons" type="button" (click)="onCancel()">close</button>
    <div class="modal-content p4">
        <ng-container *ngIf="isUploadMode; else previewOnlyHeader">
            <img src="assets/images/check-animate.gif" alt="">
            <h3>Confirmation</h3>
            <p>Are you sure, you want to upload - {{ data?.fileName }}</p>
        </ng-container>
        <ng-template #previewOnlyHeader>
            <h3>PDF preview</h3>
            <p class="preview-file-name">{{ data?.fileName }}</p>
        </ng-template>

        <div *ngIf="previewUrl" class="pdf-preview-wrap">
            <iframe [src]="previewUrl" title="PDF preview" class="pdf-preview-frame"></iframe>
            <div class="pdf-toolbar-mask" aria-hidden="true"></div>
        </div>
    </div>

    <div class="modal-footer">
        <div class="button-wrapper">
            <button *ngIf="isUploadMode" class="btn btn-primary" type="button" (click)="onConfirm()">
                Yes
            </button>
            <button *ngIf="!isUploadMode" class="btn btn-primary" type="button" (click)="onCancel()">
                Close
            </button>
        </div>
    </div>
</div>